<template>
  <b-form
    @submit.prevent="$emit('submit', model)"
    @keydown.enter="$emit('submit', model)"
  >
    <b-row no-gutters>
      <b-col sm="12">
        <b-form-group label="Fecha entre">
          <b-row no-gutters>
            <b-col cols="6">
              <b-form-datepicker
                :value="model.date_min"
                class="margin-right-datepicker"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Desde"
                :label-help="null"
                :max="model.date_max"
                @input="update('date_min', $event)"
                start-weekday="1"
              />
            </b-col>
            <b-col cols="6">
              <b-form-datepicker
                :value="model.date_max"
                class="margin-left-datepicker"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Hasta"
                :label-help="null"
                :min="model.date_min"
                @input="update('date_max', $event)"
                start-weekday="1"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Nº Pedido"
          label-for="stock-number"
        >
          <b-form-input
            id="stock-number"
            :value="model.number"
            name="stock-number"
            placeholder="Nº Pedido"
            @input="update('number', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Estado"
          label-for="stock-status"
        >
          <StatusSelect
            id="stock-status"
            :value="model.status"
            :type="statusType"
            @input="update('status', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="División"
          label-for="stock-division"
        >
          <BaseSelect
            id="stock-division"
            :value="model.division"
            :resource="$data.$constants.RESOURCES.RESOURCE_DIVISIONS"
            http-method="get"
            @input="update('division', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Proveedor"
          label-for="stock-provider"
        >
          <BaseSelect
            id="stock-provider"
            :resource="$data.$constants.RESOURCES.RESOURCE_PROVIDERS"
            :value="model.provider"
            @input="update('provider', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Categoría"
          label-for="stock-category-group"
        >
          <CategoryGroupSelect
            id="stock-category-group"
            :value="model.category_group"
            @input="update('category_group', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import FormMixin from '@/mixins/formMixin'
import { ORDERS_STATUS_TYPE } from '@/api/status-api'
import StatusSelect from '@/components/status/select/StatusSelect.vue'
import CategoryGroupSelect from '@/components/category/select/CategoryGroupSelect.vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  name: 'StockListFiltersForm',
  components: {
    BaseSelect,
    CategoryGroupSelect,
    StatusSelect,
  },
  mixins: [FormMixin],
  data() {
    return {
      statusType: ORDERS_STATUS_TYPE,
    }
  },
}
</script>

<style scoped>
.margin-left-datepicker {
  margin-left: 5px;
}
.margin-right-datepicker {
  margin-right: 5px;
}
</style>
